import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { Config } from '../.env.js';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UpdatePasswordReview = () => {
    const [Password, setpassword] = useState("");
    const [ConfirmPassword, setconfirmpassword] = useState("");
    const location = useLocation();
    const email = location.state?.email;
    const navigate = useNavigate();

    useEffect(() => {
        if (!email) {
            toast.error("Email is missing. Redirecting...");
            navigate("/"); // fallback in case someone comes directly
        }
    }, [email, navigate]);

    const handleUpdatePassword = async () => {
        try {
            const response = await fetch(`${Config.API_URL}/api/update-review`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    password: Password,
                    confirmPassword: ConfirmPassword,
                }),
            });

            const data = await response.json();

            if (data.success) {
                toast.success('Password updated successfully');
                navigate("/review-login", { replace: true });
            } else {
                toast.error(data.message || 'Failed to update password');
            }
        } catch (error) {
            toast.error(`Error updating password: ${error.message}`);
        }
    };
    return (
        <div className='imgfull'>
            <div className='container1 has-text-centered mt-5'>
                <div className='logo-card'>
                    <figure className="image is-64x64">
                        {/* <img src={logo} alt="Logo" /> */}
                    </figure>
                </div>
                < div className='container'>
                    <h1 className='title mt-5 has-text-white'>Update Password
                    </h1>
                    <div className='field '>
                        <label className="label  has-text-white">Password</label>
                        <div className="control  has-icons-right my-input">

                            <div className='colomn'>
                                <input className="input is-rounded "
                                    type="Password"
                                    placeholder="Password"
                                    value={Password}
                                    onChange={(e) => setpassword(e.target.value)}
                                />

                                <span className="icon is-small is-left">
                                    <i className="fas fa-key"></i>
                                </span>
                            </div>

                        </div>
                    </div>


                    <div className='field mt-2 '>
                        <label className="label  has-text-white">Confirm Password</label>
                        <div className=" has-icons-right my-input">
                            <div className='colomn'>
                                <input className="input is-rounded "
                                    type="password"
                                    placeholder="Confirm Password"
                                    value={ConfirmPassword}
                                    onChange={(e) => setconfirmpassword(e.target.value)}

                                />
                                {Password && ConfirmPassword && (
                                    <div className='has-text-left'>
                                        <small>
                                            {Password === ConfirmPassword ? (<span className='has-text-success icon is-small is-left'>

                                                <i className="fas fa-check-circle"></i>
                                            </span>
                                            ) : (<span className='has-text-danger icon is-small is-right'>

                                                <i className='fas fa-times-circle '></i>
                                            </span>
                                            )}
                                        </small>

                                    </div>

                                )}

                            </div>
                        </div>
                    </div>
                    <div className="field">
                        <div className="control my-input ">

                            <button className="button is-primary is-rounded  is-focused is-medium is-fullwidth " disabled={!Password || !ConfirmPassword || Password !== ConfirmPassword} onClick={handleUpdatePassword}>
                                Back to SignIn
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdatePasswordReview; 